// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__29uxB","icon":"SortAdornment_icon__RUBic","up":"SortAdornment_up__b4FBX","down":"SortAdornment_down__1OxYR","active":"SortAdornment_active__2Tnk_"};